(function ($) {
  var ecl;
  var config;
  var ecl = {
    _callApi: function (
      urn,
      method,
      data,
      callback,
      erroCallback = undefined,
      headers = {}
    ) {
      $.ajax({
        url: urn,
        method: method,
        data: data,
        contentType: "application/json",
        cache: false,
        processData: false,
        ...headers,
        success: eval(callback), // call back function and it returns to relevent function
        error: erroCallback,
      });
    },
  };
  window.ecl = ecl;

  /*
   * Config is used for set APIKEY, APIHOST and SiteId
   * @file config.js
   */

  config = {
    format: "html",
    apiKey: "",
    apiHost: "",
    siteId: 2,

    setApiKey: function (value) {
      if ("" != value && value) {
        config.apiKey = value;
      }
    },

    setApiHost: function (value) {
      if ("" != value && value) {
        config.apiHost = value;
      }
    },

    setSiteId: function (value) {
      if ("" != value && value) {
        config.siteId = value;
      }
    },
    // @Sonu: to use throughout the application
    acceptedUploadFileFormats: [
      "doc",
      "docx",
      "pub",
      "ppt",
      "pptx",
      "jpeg",
      "jpg",
      "tif",
      "tiff",
      "pdf",
    ],
  };
  window.config = config;
  // @Sonu: Handle methods related to design uploader
  const printErrors = (xhr, element) => {
    const message = [];
    if (xhr.responseJSON) {
      if (xhr.responseJSON.errors) {
        for (const k in xhr.responseJSON.errors) {
          if (xhr.responseJSON.errors.hasOwnProperty(k)) {
            message.push(xhr.responseJSON.errors[k]);
          }
        }
      } else {
        message.push(xhr.responseJSON.message);
      }
    } else {
      message.push(xhr.responseText);
    }
    element.text(message);
  };
  const validateFile = (files) => {
    $(".file-validation-error").text("");
    let ext = "";
    const maxUploadSize = $("#MAX_FILE_SIZE").val();
    let fileSize = maxUploadSize + 1;
    if (files[0]) {
      const fileName = files[0].name;
      ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
      fileSize = files[0].size;
    }
    if (window.config.acceptedUploadFileFormats.indexOf(ext) === -1) {
      const acceptedUploadFileFormats = window.config.acceptedUploadFileFormats.map(
        (i) => " ." + i
      );
      $(".file-validation-error").text(
        `Unsupported file type selected. Supported file types: ${acceptedUploadFileFormats}`
      );
      return false;
    }
    if (fileSize > maxUploadSize) {
      $(".file-validation-error").text(
        `File size must be less than or equal to: ${$(
          "#MAX_FILE_SIZE_HUMAN"
        ).val()}`
      );
      return false;
    }
    showFiles(files);
    return true;
  };
  const showFiles = (files) => {
    $(".choose-file-label").text(files[0].name);
  };
  const designUploadHandlers = {
    handleStartFileChange: () => {
      $("#downloadStartFileModal").on("shown.bs.modal", function () {
        const productVal = $("#productSelection .products").val();
        const productText = $(
          "#productSelection .products option:selected"
        ).text();
        const sizeText = $("#productSelection .sizes option:selected").text();
        let finishOptionText = "";
        const finishOption = $(
          "#productSelection .finishOption option:selected"
        ).text();
        if (finishOption != null && finishOption != "None") {
          finishOptionText = finishOption;
        }
        const option = `<option value="${productVal}">${productText} ${sizeText} ${finishOptionText} </option>`;
        const starterUrl = $(".starter-url").val();
        ecl._callApi(
          starterUrl,
          "GET",
          {},
          function (response) {
            $(".sub-title").text(
              "We've created a few simple starter files to help you build your project."
            );
            $(".starter-files-links").html(response);
          },
          function (error) {
            $(".sub-title").text(
              "OOP'S! Starter file is not available for this product."
            );
          }
        );
        $(".starter-file-product").html(option);
      });
    },
    handleProductChange: ($form) => {
      // add listener on product change
      let prevURLProduct = $(".prev-url-product").val();
      $("#productSelection .products").on("change", function () {
        var productClassId = $(this).val();
        var url = $("input.product-option-url").val();
        url = url.replace(":id", productClassId);
        $form.find(".productClassId").val(productClassId);
        $(".choose-upload-btn").hide();
        $(".starter-file").hide();

        $("#productSelection .uploadSize").hide();
        $("#productSelection .uploadFinishOption").hide();
        if (!productClassId) {
          $form.find(".productClassId").val("");
          $form.find(".finishId").val("");
          $form.find(".sizeId").val("");
          return false;
        }
        // need to uncommnent once ecl object is accessible on window.
        ecl._callApi(url, "GET", {}, function (response) {
          const finishArr = response.data.finishOptions;
          const sizesArr = response.data.sizes;
          var sizeId = sizesArr[0].id;
          var finishId = finishArr[0].id;

          $form.find(".productClassId").val(productClassId);
          if (
            prevURLProduct &&
            $("#sizeId").val() !== null &&
            $("#finishId").val() !== null &&
            $("#finishId").val() !== ""
          ) {
            sizeId = $("#sizeId").val();
            finishId = $("#finishId").val();
          }

          $form.find(".sizeId").val(sizeId);
          $form.find(".finishId").val(finishId);
          //For Starter File Url change
          window.designUploader.updateStarterUrl(sizeId, finishId);
          // Create size option drop down
          window.designUploader.createOption(
            sizesArr,
            $(".sizes"),
            $(".uploadSize"),
            "id",
            "name",
            sizeId
          );
          // trigger change
          $("#productSelection .sizes").trigger("change");
          $(".choose-upload-btn").show();
          $(".starter-file").show();
        });
      });
    },
    handleFileChange: ($form) => {
      /*Drag and drop Code starts here*/
      $(".box")
        .on(
          "drag dragstart dragend dragover dragenter dragleave drop",
          function (e) {
            window.designUploader.files = [];
            e.preventDefault();
            e.stopPropagation();
          }
        )
        .on("dragover dragenter", function () {
          window.designUploader.files = [];
          $(".box").addClass("is-dragover");
        })
        .on("dragleave dragend drop", function () {
          window.designUploader.files = [];
          $(".box").removeClass("is-dragover");
        })
        .on("drop", function (e) {
          window.designUploader.files = [];
          const files = e.originalEvent.dataTransfer.files;
          const isValid = validateFile(files);
          if (isValid) {
            $form.find("input[type=file]")[0].files = files;
            window.designUploader.files = files;
            $(".upload-process-message").css({
              display: "flex",
            });
            $form.trigger("submit");
          }
        });

      $form.on("change", "input[type=file]", function (e) {
        const files = this.files;
        const isValid = validateFile(files);
        if (isValid) {
          window.designUploader.files = files;
          $form.trigger("submit");
        }
      });
      /*Drag and drop Code ends here*/
    },
    handleSizeChange: ($form) => {
      // set value of sizeId in form
      let prevURLProduct = $(".prev-url-product").val();
      $("#productSelection .sizes").on("change", function () {
        const sizeId = $(this).val();
        const maxColor = $(this).find("option:selected").data("max-color");
        let finshOptionUrl = $("input.product-finish-option-url").val();
        finshOptionUrl = finshOptionUrl.replace(":id", sizeId);
        $form.find(".maxColors").val("");
        //$form.find(".finishId").val("");
        if (!sizeId) {
          return false;
        }
        $form.find(".maxColors").val(maxColor);
        $(".choose-upload-btn").hide();
        $(".starter-file").hide();
        // need to uncommnent once ecl object is accessible on window.
        ecl._callApi(finshOptionUrl, "GET", {}, function (response) {
          const finishArr = response.data;
          var finishId = finishArr[0].id;
          if (
            prevURLProduct &&
            $("#finishId").val() !== null &&
            $("#finishId").val() !== "" &&
            finishArr.length > 1
          ) {
            finishId = $("#finishId").val();
          }
          $form.find(".finishId").val(finishId);

          //For Starter File Url change
          window.designUploader.updateStarterUrl(
            sizeId,
            $form.find(".finishId").val()
          );
          // Create finish option drop down
          window.designUploader.createOption(
            finishArr,
            $(".finishOption"),
            $(".uploadFinishOption"),
            "id",
            "name",
            finishId
          );
          $(".choose-upload-btn").show();
          $(".starter-file").show();
        });

        $form.find(".sizeId").val($(this).val());
      });
    },
    handleFinishOptionChange: ($form) => {
      // set value of finishOptionId in form
      $("#productSelection .finishOption").on("change", function () {
        $(".choose-upload-btn").hide();
        $(".starter-file").hide();
        $form.find(".finishId").val($(this).val());
        let sizeId = $form.find(".sizeId").val();
        //For Starter File Url change
        window.designUploader.updateStarterUrl(sizeId, $(this).val());
        $(".choose-upload-btn").show();
        $(".starter-file").show();
      });
    },
    handleUpload: ($form) => {
      // handle form submit
      $form.on("submit", function (e) {
        e.preventDefault();
        $(".file-validation-error").text("");
        $(".back-btn").hide();
        const action = $form.attr("action");
        let formData = new FormData($form[0]);

        formData = window.designUploader.handleFileInFormData($form); // Delete function compatibility issue in IE
        $(".upload-process-message").css({
          display: "flex",
        });
        ecl._callApi(
          action,
          "POST",
          formData,
          function (result) {
            $(".box-file").val("");
            $(".file-validation-error").text("");
            $(".choose-file-label").text("");
            $form.trigger("reset");
            const url = $(".review-upload-url").val();
            window.location.href = url;
          },
          function (xhr) {
            $(".back-btn").show();
            const message = [];
            $(".upload-process-message").css({
              display: "none",
            });
            if (xhr.responseJSON) {
              if (xhr.responseJSON.errors) {
                for (const k in xhr.responseJSON.errors) {
                  if (xhr.responseJSON.errors.hasOwnProperty(k)) {
                    message.push(xhr.responseJSON.errors[k]);
                  }
                }
              } else {
                message.push(xhr.responseJSON.message);
              }
            }
            $(".file-validation-error").text(`${message}.`);
          },
          {
            contentType: false,
          }
        );
      });
    },
    handleChooseFileClick: () => {
      // add handler to choose file button
      $(".choose-upload-btn").click(function () {
        /*below statement is to handle scroll top */
        $("html, body").animate({ scrollTop: 0 }, 400);
        $(".choose-file-label").html(
          "<strong>Choose a file</strong><span class= 'box-dragndrop'> or drag it here</span >."
        );
        $("#upload-step-1").hide();
        $("#upload-step-3").fadeIn("slow");
      });
    },
    handleBackClick: () => {
      // add handler for back button
      $(".back-btn").click(function () {
        /*below statement is to handle scroll top */
        $("html, body").animate({ scrollTop: 0 }, 400);
        $(".file-validation-error").text("");
        $(".choose-file-label").text("");
        $(".box-file").val("");
        $("#upload-step-3").hide();
        $("#upload-step-1").fadeIn("slow");
      });
    },
  };
  //
  const designUploader = {
    files: [],
    __init: () => {
      $(".dropdown-toggle").dropdown();
      const $form = $("#formUpload");

      designUploadHandlers.handleProductChange($form);
      designUploadHandlers.handleStartFileChange();
      designUploadHandlers.handleFileChange($form);
      designUploadHandlers.handleSizeChange($form);
      designUploadHandlers.handleFinishOptionChange($form);
      designUploadHandlers.handleUpload($form);
      designUploadHandlers.handleChooseFileClick();
      designUploadHandlers.handleBackClick();
      // if product selected call other params
      const prevURLProduct = $(".prev-url-product").val();
      // trigger product change if product Id is already selected
      if (prevURLProduct) {
        $("#productSelection .products").val($("#productClassId").val());
        $("#productSelection .products").trigger("change");
      } else {
        $("#productSelection .products").val("");
      }
    },
    createOption: (
      data,
      elementId,
      parentElementId,
      keyToGet,
      valToGet,
      preSelectId
    ) => {
      let option = "";
      $.each(data, function (key, val) {
        option += `<option  ${
          val[keyToGet] == preSelectId ? `selected="selected"` : ""
        } value='${val[keyToGet]}' ${
          val.max_color ? `data-max-color='${val.max_color}'` : ""
        }>${val[valToGet]}</option>`;
      });
      elementId.html(option);
      if (data.length > 1) {
        parentElementId.show();
      } else {
        parentElementId.hide();
      }
    },
    updateStarterUrl: (sizeId, finishOptionId) => {
      let url = `https://${window.location.hostname}/download-starter-files-${sizeId}_${finishOptionId}`;
      $(".starter-url").val(url);
      $(".starter-files-links").html("");
    },
    acceptDesign: (designId) => {
      $(".next-btn").prop("disabled", true);
      $(".file-validation-error").text("");
      ecl._callApi(
        `${$(".accept-design-url").val().replace("designId", designId)}`,
        "PATCH",
        {},
        function (response) {
          $(".next-btn").prop("disabled", false);
        },
        function (error) {
          $(".next-btn").prop("disabled", false);
          printErrors(xhr, $(".file-validation-error"));
        }
      );
    },
    skipDesign: (designId) => {
      $(".next-btn").prop("disabled", true);
      $(".file-validation-error").text("");
      ecl._callApi(
        `${$(".skip-design-url").val().replace("designId", designId)}`,
        "PATCH",
        {},
        function (response) {
          $(".next-btn").prop("disabled", false);
        },
        function (xhr) {
          $(".next-btn").prop("disabled", false);
          printErrors(xhr, $(".file-validation-error"));
        }
      );
    },
    handleFileInFormData: ($form) => {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      var data = new FormData();
      var formData = new FormData($form[0]);
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        $.each($form.find('[type="hidden"]'), function (index, element) {
          data.append($(element).attr("name"), $(element).attr("value"));
        });
      } else {
        formData.delete("uploadFile");
        data = formData;
      }
      data.append("uploadFile", window.designUploader.files[0]);
      return data;
    },
  };
  // attach designUploader to window
  window.designUploader = designUploader;

  const uploadReviewHandler = {
    handleSkipChange: () => {
      $('.custom-skip-checkbox').on('click', function() {
        let jThis = $(this);
        let checkbox = jThis.siblings('input[type="checkbox"].accept-skip-design-file');
        let designId = checkbox.data("design-id");
        if (jThis.hasClass('checked')) {
            jThis.removeClass('checked');
            checkbox.prop('checked', false).change();
            window.designUploader.acceptDesign(designId);
        } else {
          jThis.addClass('checked');
          checkbox.prop('checked', true).change();
          window.designUploader.skipDesign(designId);
        }
      });
    },
    handleSideSelection: () => {
      $(".side-selection").on("change", function () {
        const isChecked = $(this).prop("checked");
        $(this)
          .prev("input")
          .val(isChecked ? 1 : 2);
      });
    },
    handleImageClick: () => {
      $(".image-container").click(function () {
        $(this).toggleClass("active-img");
      });
    },
  };

  const uploadReview = {
    __init: () => {
      uploadReviewHandler.handleSkipChange();
      uploadReviewHandler.handleSideSelection();
      uploadReviewHandler.handleImageClick();
    },
  };
  window.uploadReview = uploadReview;

  // For Order Review
  const orderReviewHandler = {
    handleOrderReviewImageChange: () => {
      $(".order-front-img").on("click", function () {
        $(".order-front-img").addClass("active");
        $(".order-back-img").removeClass("active");
        $(".order-full-img-wrap").find(".img-1").show();
        $(".order-full-img-wrap").find(".img-2").hide();
        $(".next-btn").show();
        $(".looks-good-btn").hide();
      });
      $(".order-back-img").on("click", function () {
        window.orderReview.backImagePreview();
      });
    },
    handleNextBtnChange: () => {
      $(".next-btn").click(function () {
        window.orderReview.backImagePreview();
      });
    },
  };
  // script for order review page
  const orderReview = {
    __init: () => {
      orderReviewHandler.handleOrderReviewImageChange();
      orderReviewHandler.handleNextBtnChange();
    },
    backImagePreview: () => {
      $(".order-back-img").addClass("active");
      $(".order-front-img").removeClass("active");
      $(".order-full-img-wrap").find(".img-2").show();
      $(".order-full-img-wrap").find(".img-1").hide();
      $(".next-btn").hide();
      $(".looks-good-btn").show();
    },
  };
  window.orderReview = orderReview;
  // script for alternate side selection
  const alternateSideHandler = {
    handleMyDesignAndTemplateButton: () => {
      $(".choose-template").on("click", function (e) {
        e.preventDefault();
        const url = $(this).attr("href");
        const designId = $(".selected-design").val();
        const type = $(".selected-design").data("type");
        let parameters = {};
        if (type == 1) {
          parameters = {
            frontId: designId,
            frontDesignType: "uploaded",
            frontDesignIntention: "select",
            intention: "select",
            displaySide: "front",
            designId: designId,
          };
        } else {
          parameters = {
            designId: designId,
            side: "back",
            backRequired: "no",
            intention: "select",
            backDesignType: "uploaded",
            displaySide: "back",
          };
        }
        ecl._callApi(
          "/ec/ajax/design/select",
          "POST",
          parameters,
          function (res) {
            window.location.href = url;
          },
          function (res) {
            console.log(res);
          },
          {
            contentType: "application/x-www-form-urlencoded",
            processData: true,
            cache: true,
          }
        );
      });
    },
  };
  const alternateSide = {
    __init: () => {
      alternateSideHandler.handleMyDesignAndTemplateButton();
    },
  };
  window.alternateSide = alternateSide;
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/scripts/modules/ecr_lara_min.js